import React from 'react';
import { Column, Columns } from '../../../../styled/Columns/wrappers';
import useContext from '../../../../hooks/useContext';
import { ProductContext } from '../providers/ProductProvider';
import { CheckIcon } from '../../../../styled/Icon';
import VariantPanelOption from '../../../../styled/VariantPanelOption';

interface IVariantInStockOption {
  variant: IOptionResponse;
  isConfigurationProduct: boolean;
  onSelect: () => void;
}

export default function VariantInStockOption({
  variant,
  isConfigurationProduct,
  onSelect,
}: IVariantInStockOption) {
  const {
    id,
    price,
    specifications,
    name,
    description,
    configurations: variantConfigurations,
  } = variant;

  const { configurations, variantId: productVariantId } = useContext(ProductContext);
  const validProductConfigurations = configurations?.filter((pc) => pc.items.length > 1) || [];
  const isSelectedVariant = id === productVariantId;
  const mappedVariantConfigurations = validProductConfigurations.map((vpc) => ({
    label: vpc.label,
    value: variantConfigurations[vpc.type].name,
  }));

  return (
    <>
      <VariantPanelOption
        imageUrl={variant.image}
        variantName={name}
        variantDescription={description}
        variantInfo={specifications.variantInfo as string}
        variantConfigurations={isConfigurationProduct ? mappedVariantConfigurations : undefined}
        onClickButton={onSelect}
        buttonTone={isSelectedVariant ? 'positive' : undefined}
        priceObject={{
          sellingPrice: price.price,
          referencePrice: price.referencePrice,
          originalPrice: price.originalPrice,
          pilPrice: price.pilPrice,
          componentPrice: price.componentPrice,
        }}
        buttonContent={
          <>
            {!isSelectedVariant && 'Välj'}
            {isSelectedVariant && (
              <Columns className="valign-middle space-1">
                <Column>Vald</Column>
                <Column>
                  <CheckIcon />
                </Column>
              </Columns>
            )}
          </>
        }
      />
    </>
  );
}
